import { FormData, RuleCheckItem, RuleCheckResult } from '../../Components/FormBuilder/types';
import { SelectionListItem } from '../../Components/Navigation/SelectionList';

export enum ActionTypes {
  SET_CURRENT_STEP = 'APP/SET_CURRENT_STEP',
  SET_SELECTED_SYSTEM = 'APP/SET_SELECTED_SYSTEM',
  SET_SELECTED_PRODUCT_TYPE = 'APP/SET_SELECTED_PRODUCT_TYPE',
  SET_SYSTEM_DATA_OPTIONS = 'APP/SET_SYSTEM_DATA_OPTIONS',
  SET_CONFIGURATOR_MENU_OPTIONS = 'APP/SET_CONFIGURATOR_MENU_OPTIONS',
  SET_SELECTED_CONFIGURATOR_MENU = 'APP/SET_SELECTED_CONFIGURATOR_MENU',
  SET_SELECTED_COMPONENT = 'APP/SET_SELECTED_COMPONENT',
  SET_CONDITIONS_ACCEPTED = 'APP/SET_CONDITIONS_ACCEPTED',
  SET_PRODUCT_PARAM_VALID = 'APP/SET_PRODUCT_PARAM_VALID',
  SET_LANGUAGES = 'APP/SET_LANGUAGES',
  SET_COUNTRIES = 'APP/SET_COUNTRIES',
  SET_PRODUCT_PARAMETER_FORM_DATA = 'APP/SET_PRODUCT_PARAMETER_FORM_DATA',
  SET_PRODUCT_PARAMETER_WARNINGS = 'APP/SET_PRODUCT_PARAMETER_WARNINGS',
  SET_PRODUCT_PARAMETER_WARNINGS_APPROVED = 'APP/SET_PRODUCT_PARAMETER_WARNINGS_APPROVED',
  SET_ACCESS_DENIED_ERROR = 'APP/SET_ACCESS_DENIED_ERROR',
  CLEAR_ACCESS_DENIED_ERROR = 'APP/CLEAR_ACCESS_DENIED_ERROR',
  SET_MENU = 'APP/SET_MENU',
  SET_USER_FLAGS = 'APP/SET_USER_FLAGS',
}

export interface SetCurrentStepAction {
  type: ActionTypes.SET_CURRENT_STEP;
  payload: string;
}

export interface SetSelectedSystemAction {
  type: ActionTypes.SET_SELECTED_SYSTEM;
  payload: string | null;
}

export interface SetSelectedProductTypeAction {
  type: ActionTypes.SET_SELECTED_PRODUCT_TYPE;
  payload: string | null;
}

export interface SetSystemDataOptionsAction {
  type: ActionTypes.SET_SYSTEM_DATA_OPTIONS;
  payload: [];
}

export interface SetConfiguratorMenuOptionsAction {
  type: ActionTypes.SET_CONFIGURATOR_MENU_OPTIONS;
  payload: [];
}

interface SetSelectedConfiguratorMenuAction {
  type: ActionTypes.SET_SELECTED_CONFIGURATOR_MENU;
  payload: string;
}

interface SetSelectedComponentAction {
  type: ActionTypes.SET_SELECTED_COMPONENT;
  payload: IdentifierData;
}

interface SetProductParamValidAction {
  type: ActionTypes.SET_PRODUCT_PARAM_VALID;
  payload: ProductFieldValidation;
}

interface SetLanguagesAction {
  type: ActionTypes.SET_LANGUAGES;
  payload: [];
}

interface SetCountriesAction {
  type: ActionTypes.SET_COUNTRIES;
  payload: [];
}
interface SetLoginRequiredAction {
  type: ActionTypes.SET_LOGIN_REQUIRED;
}
interface ReceiveLoginAction {
  type: ActionTypes.RECEIVE_LOGIN;
}
interface SetAuthMessageAction {
  type: ActionTypes.SET_AUTH_MESSAGE;
  payload: [];
}
interface ClearAuthMessagesAction {
  type: ActionTypes.CLEAR_AUTH_MESSAGES;
}

interface SetProductParameterFormDataAction {
  type: ActionTypes.SET_PRODUCT_PARAMETER_FORM_DATA;
  productIdentifier: string;
  formData: FormData;
}

interface SetProductParameterWarningsAction {
  type: ActionTypes.SET_PRODUCT_PARAMETER_WARNINGS;
  warnings: RuleCheckItem[];
}

interface SetProductParameterWarningsApprovedAction {
  type: ActionTypes.SET_PRODUCT_PARAMETER_WARNINGS_APPROVED;
}

interface SetAccessDeniedErrorAction {
  type: ActionTypes.SET_ACCESS_DENIED_ERROR;
  payload: string;
}

interface ClearAccessDeniedErrorAction {
  type: ActionTypes.CLEAR_ACCESS_DENIED_ERROR;
}

export interface MenuPayload {
  systems: SelectionListItem[];
  productTypes: SelectionListItem[];
}

interface SetMenuAction {
  type: ActionTypes.SET_MENU;
  payload: MenuPayload;
}

export interface UserFlags {
  showPreCalc: boolean;
}

interface SetUserFlagsAction {
  type: ActionTypes.SET_USER_FLAGS;
  payload: UserFlags;
}

export interface ProductFieldValidation {
  [name: string]: boolean | RuleCheckResult;
}

export interface IdentifierData {
  identifier: string;
  title: string;
}

export type AppActions =
  | SetCurrentStepAction
  | SetSelectedSystemAction
  | SetSelectedProductTypeAction
  | SetSystemDataOptionsAction
  | SetConfiguratorMenuOptionsAction
  | SetSelectedConfiguratorMenuAction
  | SetSelectedComponentAction
  | SetProductParamValidAction
  | SetLanguagesAction
  | SetCountriesAction
  | ReceiveLoginAction
  | SetAuthMessageAction
  | SetLoginRequiredAction
  | ClearAuthMessagesAction
  | SetProductParameterFormDataAction
  | SetProductParameterWarningsAction
  | SetProductParameterWarningsApprovedAction
  | SetAccessDeniedErrorAction
  | ClearAccessDeniedErrorAction
  | SetMenuAction
  | SetUserFlagsAction;
